export default __webpack_public_path__ + "static/media/tamb.0eec3902.mp3";